import { render } from "./button.vue?vue&type=template&id=37262a61"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=37262a61&lang=scss"

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/AI_Playground/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__